/**
 * @param {{ courseId?: { _id?: string } | string | null }} announcement
 * @returns {string}
 */
export function resolveAnnouncementCourseId(announcement) {
  const courseId = announcement?.courseId;
  if (courseId == null) {
    return "";
  }
  if (typeof courseId === "string") {
    return courseId;
  }
  if (typeof courseId === "object" && courseId._id != null) {
    return String(courseId._id);
  }
  return "";
}

/**
 * @param {{ _id?: string, titulo?: string, nombre?: string }} course
 * @returns {{ value: string, label: string } | null}
 */
function toCourseFilterOption(course) {
  const value = String(course?._id ?? "").trim();
  if (!value) {
    return null;
  }
  const label = String(course.titulo || course.nombre || value).trim() || value;
  return { value, label };
}

/**
 * Unique course options for the announcements list filter.
 *
 * @param {Array<{ _id?: string, titulo?: string, nombre?: string }> | null | undefined} courses
 * @returns {Array<{ value: string, label: string }>}
 */
export function buildAnnouncementCourseFilterOptions(courses) {
  if (!Array.isArray(courses)) {
    return [];
  }
  const seen = new Set();
  const options = [];
  courses.forEach((course) => {
    const option = toCourseFilterOption(course);
    if (!option || seen.has(option.value)) {
      return;
    }
    seen.add(option.value);
    options.push(option);
  });
  return options;
}

/**
 * When a course is selected, only announcements of that course remain.
 * Global announcements are excluded. An empty filter keeps the current list.
 *
 * @param {Array<{ courseId?: { _id?: string } | string | null }>} announcements
 * @param {string} courseFilterId
 * @returns {Array<{ courseId?: { _id?: string } | string | null }>}
 */
export function filterAnnouncementsByCourse(announcements, courseFilterId) {
  if (!Array.isArray(announcements)) {
    return [];
  }
  const selected = String(courseFilterId || "").trim();
  if (!selected) {
    return announcements;
  }
  return announcements.filter((item) => resolveAnnouncementCourseId(item) === selected);
}
